var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGaranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43269 0.875H14.5673C15.0824 0.875 15.5 1.29258 15.5 1.80769V9.625C15.5 13.7671 12.1421 17.125 8 17.125C3.85786 17.125 0.5 13.7671 0.5 9.625V1.80769C0.5 1.29258 0.917581 0.875 1.43269 0.875Z",
    fill: "#1C2631"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42188 4.00391C9.70312 4.00391 10.7832 4.45508 11.6621 5.35742L10.4141 6.45312C9.90234 5.94141 9.23828 5.68555 8.42188 5.68555C7.67969 5.68555 7.05078 5.9375 6.53516 6.44141C6.02344 6.94141 5.76758 7.56836 5.76758 8.32227C5.76758 9.07617 6.01953 9.70508 6.52344 10.209C7.04297 10.7051 7.67578 10.9531 8.42188 10.9531C9.15625 10.9531 9.76367 10.7363 10.2441 10.3027V9.17773H8.04688V7.54297H11.9727V10.9297C11.5781 11.457 11.0664 11.873 10.4375 12.1777C9.8125 12.4824 9.14062 12.6348 8.42188 12.6348C7.17578 12.6348 6.11133 12.2266 5.22852 11.4102C4.35742 10.5898 3.92188 9.56055 3.92188 8.32227C3.92188 7.08789 4.35742 6.06055 5.22852 5.24023C6.10352 4.41602 7.16797 4.00391 8.42188 4.00391Z",
    fill: "url(#paint0_linear_11_2519)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.43269 0.875H14.5673C15.0824 0.875 15.5 1.29258 15.5 1.80769V9.625C15.5 13.7671 12.1421 17.125 8 17.125C3.85786 17.125 0.5 13.7671 0.5 9.625V1.80769C0.5 1.29258 0.917581 0.875 1.43269 0.875Z",
    stroke: "url(#paint1_linear_11_2519)",
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_2519",
    x1: 12.5,
    y1: 3.5,
    x2: 4.00795,
    y2: 10.9489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B86300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B86300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_2519",
    x1: 15.875,
    y1: 0.5,
    x2: 0.754756,
    y2: 12.1313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538153,
    stopColor: "#B86300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaranty);
export default __webpack_public_path__ + "static/media/garanty.f30ef4d42e1aa13407178afb440727bc.svg";
export { ForwardRef as ReactComponent };